// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-radio-btn-landing {
    /* grid-template-columns: 0.9fr 1fr 0.5fr;
    display: grid;
    padding-top: 5px;
    padding-left: 40px; */
    display: flex;
    justify-content: center;
    background-color: white;
    z-index: 999 !important;
    border: 1px solid lightgrey;
    width: 70%;
    margin-left: 5.5%;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    padding: 10px 20px 0 0;
}

.search-radio-btn-sidepanel {
    display: flex;
    justify-content: center;
    background-color: white;
    z-index: 999 !important;
    border: 1px solid #43B02A;
    width: 60%;
    margin: auto;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 10px 10px 0px 10px;
}`, "",{"version":3,"sources":["webpack://./src/css/search-bar.css"],"names":[],"mappings":"AAAA;IACI;;;yBAGqB;IACrB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;IACjB,+BAA+B;IAC/B,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;AAC/B","sourcesContent":[".search-radio-btn-landing {\n    /* grid-template-columns: 0.9fr 1fr 0.5fr;\n    display: grid;\n    padding-top: 5px;\n    padding-left: 40px; */\n    display: flex;\n    justify-content: center;\n    background-color: white;\n    z-index: 999 !important;\n    border: 1px solid lightgrey;\n    width: 70%;\n    margin-left: 5.5%;\n    border-bottom-left-radius: 20px;\n    border-bottom-right-radius: 20px;\n    padding: 10px 20px 0 0;\n}\n\n.search-radio-btn-sidepanel {\n    display: flex;\n    justify-content: center;\n    background-color: white;\n    z-index: 999 !important;\n    border: 1px solid #43B02A;\n    width: 60%;\n    margin: auto;\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n    padding: 10px 10px 0px 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
